import studentGetters from './getters.js'
// import axios from 'axios'
import { showSuccess, showError } from '../../index.js'

export default {
  namespaced: true,
  state () {
    return {
      // Library
      libNoti: ['Vui lòng truy cập thư viện tài liệu bằng ứng dụng "TRAINING EDOC" trên thiết bị IPAD của FTC',
        "Please access the document library using the 'TRAINING EDOC' app on FTC's IPAD devices."
      ],
      trainingSchedules: [],
      trainingScheduleDetails: [],
      layout: 'So do toa nhà - The directory of building.jpg',
      // Evaluation Form
      vnEvaluation: ['Vui lòng thực hiện phiếu đánh giá tại', 'đây'],
      enEvaluation: ['Please complete the evaluation form', 'here'],
      blankScheduleData: {
        id: 0,
        name: ''
      }
    }
  },
  getters: studentGetters,
  mutations: {
    setTShs (state, payload) {
      state.trainingSchedules = payload
    },
    setTShDetails (state, payload) {
      state.trainingScheduleDetails = payload
    }
  },
  actions: {
    async getTShData (context) {
      // await axios.get(context.rootState.API_Url + 'TrainingSchedules/').then((response) => {
      await context.rootState.authAxios.get('/TrainingSchedules/').then((response) => {
        const responseData = response.data
        context.commit('setTShs', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async postTSh (context, payload) {
      await context.rootState.authAxios.post('/TrainingSchedules/', {
        name: payload.name,
        subMenuId: payload.subMenuId,
        hidden: payload.hidden,
        lang: payload.lang,
        url: payload.url
      })
      // console.log(payload)
      // try {
      //   const response = await context.rootState.authAxios.post('/TrainingSchedules/', {
      //     name: payload.name,
      //     subMenuId: payload.subMenuId,
      //     hidden: payload.hidden,
      //     createdAt: payload.createdAt,
      //     updatedAt: payload.updatedAt,
      //     author: payload.author,
      //     lang: payload.lang
      //   })
      //   showSuccess('Add successfully')
      //   return response.status
      // } catch (error) {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      //   return error.response ? error.response.status : null
      // }
    },
    async updateTSh (context, payload) {
      await context.rootState.authAxios.put(`/TrainingSchedules/${payload.id}`, {
        name: payload.name,
        subMenuId: payload.subMenuId,
        hidden: payload.hidden,
        lang: payload.lang,
        url: payload.url
      })
      // console.log(payload)
      // .then(() => {
      //   showSuccess('Update successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async deleteTSh (context, payload) {
      await context.rootState.authAxios.delete(`/TrainingSchedules/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    // TShDetail
    async getTShDetailData (context) {
      // await axios.get(context.rootState.API_Url + 'TrainingScheduleDetails/').then((response) => {
      await context.rootState.authAxios.get('/TrainingScheduleDetails/').then((response) => {
        const responseData = response.data
        context.commit('setTShDetails', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async postTShDetail (context, payload) {
      await context.rootState.authAxios.post('/TrainingScheduleDetails/', {
        name: payload.name,
        url: payload.url,
        hidden: payload.hidden,
        trainingScheduleId: payload.trainingScheduleId,
        lang: payload.lang,
        link: payload.link
      })
      // console.log(payload)
      // try {
      //   const response = await context.rootState.authAxios.post('/TrainingScheduleDetails/', {
      //     name: payload.name,
      //     url: payload.url,
      //     hidden: payload.hidden,
      //     trainingScheduleId: payload.trainingScheduleId,
      //     author: payload.author,
      //     lang: payload.lang,
      //     link: payload.link
      //   })
      //   showSuccess('Add successfully')
      //   return response.status
      // } catch (error) {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      //   return error.response ? error.response.status : null
      // }
    },
    async updateTShDetail (context, payload) {
      await context.rootState.authAxios.put(`/TrainingScheduleDetails/${payload.id}`, {
        name: payload.name,
        url: payload.url,
        hidden: payload.hidden,
        trainingScheduleId: payload.trainingScheduleId,
        lang: payload.lang,
        link: payload.link
      })
      // console.log(payload)
      // then(() => {
      //   showSuccess('Update successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async deleteTShDetail (context, payload) {
      await context.rootState.authAxios.delete(`/TrainingScheduleDetails/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    }
  }
}
